import React, { useEffect, useState } from "react";
import ratingIcon from "../../../Assets/rating.png";
import { truncateDescription } from "../../../utilities/truncateDescription";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch("https://365luxuryhomes.com/api/reviews");
        const data = await response.json();
        setReviews(data.reviews);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <div>
      <div className="w-full text-center mt-12 mb-4">
        <h2 className="text-xl text-gray-500 mb-3">Testimonials</h2>
        <h1 className="md:text-4xl text-2xl font-bold text-[#4d4b47]">
          What They're Saying About Us
        </h1>
      </div>
      <div className="swiper-container mx-auto w-full max-w-6xl overflow-hidden">
        <div className="swiper-wrapper">
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              1280: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
            modules={[Pagination, Autoplay]}
            className="lg:w-auto md:w-auto w-full lg:px-0 md:px-0 customReviewSwiper"
          >
            {reviews?.map((review, index) => (
              <SwiperSlide key={review.id} className="shadow-xl rounded-lg">
                <div
                  key={index}
                  className="swiper-slide h-auto p-6 bg-white rounded-xl flex flex-col items-start space-y-4"
                >
                  <div className="flex items-center space-x-4">
                    <img
                      src={review?.profile_photo_url}
                      alt=""
                      className="w-12 h-12  object-cover"
                    />
                    <div className="flex flex-col items-start">
                      <span className="font-semibold text-gray-800">
                        {review.author_name}
                      </span>
                      <img src={ratingIcon} alt="" className="w-20" />
                      <span className="text-sm text-[#4d4b47]">
                        {new Date(review.time * 1000).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }
                        )}
                      </span>
                    </div>
                  </div>
                  {truncateDescription}
                  <p className="text-[#4d4b47] text-left leading-relaxed">
                    {truncateDescription(review.text, 20)}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="swiper-pagination mt-4"></div>
      </div>
    </div>
  );
};

export default Testimonials;
